module.exports = __webpack_public_path__ + "img/music.ecb1ee40.svg";